<template>
  <template v-if="kycStore.kyc.internalStatus === KYC_INTERNAL_STATUS.REJECTED">
    <div class="page-header-wrapper">
      <h1>{{ $t("bnpl:kyc.result.user_document_already_used.title") }}</h1>
      <p>{{ $t("bnpl:kyc.result.user_document_already_used.subtitle") }}</p>
    </div>
    <div class="whitebox flex-column align-items-center gap-16 p-3">
      <IllustrationsError />
      <span class="illustration-title error">{{ $t("bnpl:kyc.result.user_document_already_used.illustration_title") }}</span>
    </div>
  </template>
  <template v-else>
    <template v-if="kycStore.kyc.status === KYC_STATUS.REJECTED">
      <div class="page-header-wrapper">
        <h1>{{ $t("b2b:kyc.result.rejected.title") }}</h1>
        <p>{{ $t("b2b:kyc.result.rejected.subtitle") }}</p>
      </div>
      <div class="whitebox flex-column align-items-center gap-16 p-3">
        <IllustrationsError />
        <span class="illustration-title error">{{ $t("b2b:kyc.result.rejected.illustration_title") }}</span>
      </div>
    </template>
    <template v-if="kycStore.kyc.status === KYC_STATUS.COMPLETED || kycStore.kyc.status === KYC_STATUS.APPROVED">
      <div class="page-header-wrapper">
        <h1>{{ $t("b2b:kyc.result.completed.title") }}</h1>
        <p>{{ $t("b2b:kyc.result.completed.subtitle") }}</p>
      </div>
      <div class="whitebox flex-column align-items-center gap-16 p-3">
        <IllustrationsSuccess />
        <span class="illustration-title success">{{ $t("b2b:kyc.result.completed.illustration_title") }}</span>
      </div>
    </template>
    <template v-if="kycStore.kyc.status === KYC_STATUS.CANCELLED">
      <div class="page-header-wrapper">
        <h1>{{ $t("b2b:kyc.result.cancelled.title") }}</h1>
        <p>{{ $t("b2b:kyc.result.cancelled.subtitle") }}</p>
      </div>
      <div class="whitebox flex-column align-items-center gap-16 p-3">
        <IllustrationsError />
        <span class="illustration-title error">{{ $t("b2b:kyc.result.cancelled.illustration_title") }}</span>
      </div>
    </template>
    <template v-if="kycStore.kyc.status === KYC_STATUS.MANUAL_REVIEW">
      <div class="page-header-wrapper">
        <h1>{{ $t("b2b:kyc.result.manual_review.title") }}</h1>
        <p>{{ $t("b2b:kyc.result.manual_review.subtitle") }}</p>
      </div>
      <div class="whitebox flex-column align-items-center gap-16 p-3">
        <IllustrationsWaiting />
        <span class="illustration-title primary">{{ $t("b2b:kyc.result.manual_review.illustration_title") }}</span>
      </div>
    </template>
  </template>
</template>

<script setup>
import { KYC_STATUS, KYC_INTERNAL_STATUS } from '~~/utils/const';
import { useKycStore } from '~~/stores/kyc';

const kycStore = useKycStore();
</script>

<style lang="scss" scoped>
.illustration-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 130%;

  &.error {
    color: var(--systemError);
  }

  &.success {
    color: var(--systemSuccess);
  }

  &.primary {
    color: var(--brandPrimary);
  }
}
</style>